import { useEffect, useMemo } from 'react';
import { FormAutoGenerated, NoContent, Wrapper, useStyletron } from '@visualfabriq/vf-ui-kit';
import {
  FieldItem,
  FormLayoutRow,
} from '@visualfabriq/vf-ui-kit/dist/components/molecules/form/form-auto-generated/types';

import { requiredField } from 'src/components/UIKitTweaks';
import { DataProcessingArgs } from 'src/api-new/bifrost';
import { TemplateArgType } from 'src/domain/pipelines/types';

type Props = {
  initData: Record<string, string>;
  templateArgs: DataProcessingArgs[];
  onChange: (event: Record<string, TemplateArgType>) => void;
  onValidateChange: (isValid: boolean) => void;
};

export function TemplateArgsForm(props: Props) {
  const { templateArgs, onChange, onValidateChange, initData } = props;
  const [css] = useStyletron();
  const [fields, layout] = useMemo(() => {
    const fields = templateArgs.map<FieldItem>((template) => ({
      field_id: template.key,
      field_desc: template.key,
      tooltip: template.description,
      data_type: 'text',
      ...requiredField,
    }));
    const layout: FormLayoutRow[] = templateArgs.map((args) => [{ cols: [4, 6, 12], field: args.key }]);

    return [fields, layout];
  }, [templateArgs]);

  useEffect(() => {
    if (!templateArgs.length) {
      onValidateChange(true);
    }
  }, [templateArgs]);

  return (
    <Wrapper
      direction="column"
      height="100%"
      marginBlock={200}
      className={css({
        overflowY: 'auto',
        overflowX: 'hidden',
      })}
    >
      {fields.length ? (
        <FormAutoGenerated
          initData={initData}
          fields={fields}
          layout={layout}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          onDataChange={onChange as any}
          onFormValidChange={onValidateChange}
        />
      ) : (
        <NoContent isFilterApplied hideHintMessage message="This template doesn't have any arguments to fill" />
      )}
    </Wrapper>
  );
}
